import {
  Typography,
  Avatar,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
} from "@mui/material";
import React from "react";
import WarningIcon from "@mui/icons-material/Warning";
import CircleIcon from "@mui/icons-material/Circle";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import ErrorIcon from "@mui/icons-material/Error";
import { DataGrid } from "@mui/x-data-grid";
import "./LogisticsScreen.css";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import API from "../API";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";

var types = ["Motor", "Sedan", "Doblo", "Minivan", "Panelvan", "Kamyonet"];
const cityOptions = [
  { label: "Ankara", value: 6 },
  { label: "İstanbul", value: 34 },
  { label: "İzmir", value: 35 },
  { label: "Bursa", value: 16 },
  { label: "Aydin", value: 9 },
  { label: "Kocaeli", value: 41 },
  { label: "Sakarya", value: 54 },
];
export default class DriversScreen extends React.Component {
  constructor() {
    super();

    this.state = {
      drivers: [],
      cityFilter: [6, 34, 35, 16, 9, 41, 54],
      driverCount: 0,
      verifiedOnly: false,
    };
  }

  componentDidMount() {
    this.getDriverList();
  }

  getDriverList(page) {
    API.fetch("getdrivers", {
      page,
      cityFilter: this.state.cityFilter,
      verifiedOnly: this.state.verifiedOnly,
      validOnly: this.state.validOnly,
    }).then((e) => {
      if (e.driverCount) this.state.driverCount = e.driverCount;

      this.setState({ drivers: e.drivers });
    });
  }
  render() {
    return (
      <div>
        <div>
          <FormGroup
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <InputLabel>Cities</InputLabel>
              <Select
                multiple
                value={this.state.cityFilter}
                onChange={(e) => {
                  this.setState({ cityFilter: e.target.value }, () =>
                    this.getDriverList()
                  );
                }}
                input={<OutlinedInput label="Cities" />}
                renderValue={(selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={
                          cityOptions.find((x) => x.value === value)?.label
                        }
                      />
                    ))}
                  </div>
                )}
              >
                {cityOptions.map((city) => (
                  <MenuItem key={city.value} value={city.value}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {/* Label */}
                      <span style={{ flexGrow: 1 }}>{city.label}</span>

                      {/* Check icon only if selected */}
                      {this.state.cityFilter.includes(city.value) && (
                        <CheckIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                      )}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    this.state.verifiedOnly = !this.state.verifiedOnly;
                    this.getDriverList();
                  }}
                />
              }
              label="Onay Bekliyor"
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    this.state.validOnly = !this.state.validOnly;
                    this.getDriverList();
                  }}
                />
              }
              label="Onaylanmış"
            />
          </FormGroup>
        </div>

        <Badge style={{ marginTop: 50, padding: 0 }}>
          <div style={{ padding: 24 }}>
            <Typography variant="h5">Sürücü Listesi</Typography>
          </div>
          <DataGrid
            autoHeight
            rows={this.state.drivers.map((x, i) => ({ ...x, id: i }))}
            columns={[
              {
                field: "Ad Soyad",
                flex: 1,
                renderCell: (params) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      src={
                        "https://ik.imagekit.io/tasimacim/driver/tr:w-80/" +
                        params.row._id +
                        ".jpeg"
                      }
                    />{" "}
                    {/*src={"https://tasimacim-driver-pictures.s3.eu-central-1.amazonaws.com/"+params.row._id+".jpeg"}*/}
                    <div style={{ marginLeft: 10 }}>
                      <Typography variant="body1">{params.row.name}</Typography>
                      <Typography variant="body2">
                        {params.row.email}
                      </Typography>
                    </div>
                  </div>
                ),
              },
              {
                field: "Araç",
                flex: 1,
                valueGetter: (params, row) =>
                  row.vehicles.map((x) => types[x.type]).join(","),
              },
              {
                field: "Şehir",
                flex: 1,
                valueGetter: (params, row) => API.getCityName(row.city),
              },
              {
                field: "Telefon",
                flex: 1,
                valueGetter: (params, row) => row.phone,
              },
              {
                field: " ",
                renderCell: (params) => {
                  return (
                    <a href={"../driver/" + params.row._id}>
                      <Button>
                        <ArrowForwardIcon />
                      </Button>
                    </a>
                  );
                  // return <Link to={'/driver/' + params.row._id} ><Button><ArrowForwardIcon /></Button></Link>
                },
              },
            ]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            onPaginationModelChange={(model) => {
              // this.setState({drivers: []});
              this.getDriverList(model.page);
            }}
            pageSizeOptions={[50]}
            slotProps={{
              pagination: { showFirstButton: true, showLastButton: true },
            }}
            rowCount={this.state.driverCount}
            paginationMode="server"
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#F3F4F6",
                borderRadius: 0,
              },
            }}
          />
        </Badge>
      </div>
    );
  }
}

const Badge = (props) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        boxShadow:
          "rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px",
        borderRadius: 8,
        padding: 24,
        color: "rgb(18, 24, 40)",
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
